// extracted by mini-css-extract-plugin
export default {"root":"RichList_root__hnM6o"};